import {addDays} from "date-fns";
import {CalculateTotalMinutes} from './TimeFunctions';
// Add the timecode to the existing set of timecodes. This involves adding necessary clients,projects, budgets and timecodes as needed.
// finally addng the empty entrydays. 
export const AddNewTimecode = (weekStart, data, client, project, budget, timecode, userDetails, existingTimecode)=>{

    var targetClient=null;
    for(var clientIndex=0; clientIndex < data.length; clientIndex++){
      if(data[clientIndex].clientId === client.clientId) targetClient = data[clientIndex];
    }

    if(targetClient===null){
      targetClient= {clientId: client.clientId, clientName: client.clientName, projects:[]};
      data=[...data, targetClient];
  }

  var targetProject=null;
  for(var projectIndex=0; projectIndex < targetClient.projects.length; projectIndex++){
    if(targetClient.projects[projectIndex].projectId === project.projectId) targetProject = targetClient.projects[projectIndex];
  }

  if(targetProject===null){
      targetProject= {projectId: project.projectId, projectName: project.projectName, budgets:[]};
      targetClient.projects=[...targetClient.projects,targetProject];
  }

  var targetBudget=null;
  for(var budgetIndex=0; budgetIndex < targetProject.budgets.length; budgetIndex++){
    if(targetProject.budgets[budgetIndex].budgetId === budget.budgetId) targetBudget =targetProject.budgets[budgetIndex];
  }

  if(targetBudget===null){
    targetBudget= {budgetId: budget.budgetId, budgetName: budget.budgetName, timecodes:[]};
    targetProject.budgets=[...targetProject.budgets, targetBudget];
}

const isDuplicate = targetBudget.timecodes.some(q => 
  q.taskId === timecode.taskId &&
  q.entryDays.some(entry => entry.date.toString() === weekStart.toString())
);

if (isDuplicate) {
  throw Error("Attempted to add duplicate timecode for this week");
}

    var instance = {
      userStartDate: userDetails.userStartDate,
      userEndDate: userDetails.userEndDate,
      taskId: timecode.taskId, 
      taskName: timecode.taskName, 
      taskStartDate: timecode.taskStartDate,
      taskEndDate: timecode.taskEndDate,
      budgetId: targetBudget.budgetId,
      projectId: targetProject.projectId,
      projectName: targetProject.projectName,
      projectStartDate: project.projectStartDate,
      projectEndDate: project.projectEndDate,
      clientId: targetClient.clientId,
      entryDays: []
    };
    
    if (existingTimecode) targetBudget.timecodes=[...targetBudget.timecodes, inflateExistingEntryRow(weekStart, existingTimecode)];
    else targetBudget.timecodes=[...targetBudget.timecodes, inflateTimecodeEntryRow(weekStart, instance)];
    return data;
}

export const inflateExistingEntryRow = (weekStart, row) => {
  const projectStart = new Date(row.projectStart);
  const projectEnd = new Date(row.projectEnd);
  const timecodeStart = new Date(row.taskStart);
  const timecodeEnd = new Date(row.taskEnd);

  let entrydays = [];
  row.entryDays = entrydays;

  // Loop through each day in the week (7 days) and check if a time entry exists for it
  for (let i = 0; i < 7; i++) {
    let date = addDays(weekStart, i);
    let target = row.timeEntries.find(q => new Date(q.date).toISOString() === date.toISOString());
    let status = "error";
    if (!target) {
      switch (true) {
        case (date > projectEnd || date < projectStart):
          status = "outOfProjectRange";
          break;
        case (date > timecodeEnd || date < timecodeStart):
          status = "outOfTimecodeRange";
          break;
        default:
          status = "empty"; 
          break;
      }
      target = {
        date: date,
        status: status,
        totalMinutes: 0,
        entries: [],
        isReviewed: false,
        casualMonthLocked: false
      };
    } else {
      // Disable row for add timecode selector
      row.isDisabled = true;

      // Set metadata for existing entries
      let entryDayEntries = target.timeEntryDetails;
      let totalMinutes = 0;
      entryDayEntries.forEach(entry => {
        entry.id = entry.timeEntryDetailId ;

        entry.totalMinutes = CalculateTotalMinutes(entry.start,entry.end,entry.break);
        totalMinutes += entry.totalMinutes;

        entry.startEndValidationState='none';
        entry.breakValidationState='none';
        entry.isValid=false;
        entry.isReviewed=target.isReviewed;
      });

      // total minutes check for existing PW data with no entry details
      if (totalMinutes === 0) {
        // If time entry exists, update the target with entry details
        target = {
          date: date,
          status: 'closed',
          totalMinutes: target.hours*60,
          entries: target.timeEntryDetails,
          isReviewed: false,
          casualMonthLocked: target.casualMonthLocked,
      };
      } else {
        // If time entry exists, update the target with entry details
        target = {
        date: date,
        status: 'open',
        totalMinutes: totalMinutes,
        entries: target.timeEntryDetails,
        isReviewed: target.isReviewed,
        casualMonthLocked: target.casualMonthLocked,
      };
      }
      
    }
    // Add the target entry for this day
    entrydays.push(target);
  }

  return row;
};


// Add entryDay records as needed to the row. this will fill in the blanks so every day in the week has at least a blank entry
export const inflateTimecodeEntryRow = (weekStart, row) => {
  const projectStart = new Date(row.projectStartDate);
  const projectEnd = new Date(row.projectEndDate);
  const timecodeStart = new Date(row.taskStartDate);
  const timecodeEnd = new Date(row.taskEndDate);

  var entrydays = [];
  
  for(var i=0; i < 7; i++){    
    let date = addDays(weekStart, i);
    var target = row.entryDays.find(q=> q.date === date);
    var status = "error";
    if (target===undefined){
      switch (true) {
        case (date > projectEnd || date < projectStart):
          status = "outOfProjectRange";
          break;
        case (date > timecodeEnd || date < timecodeStart):
          status = "outOfTimecodeRange";
          break;
        default:
          status = "empty";
          break;
      }
      target= {
        date:date,
        status:status,
        totalMinutes:0,
        entries:[],
        isReviewed: false,
        casualMonthLocked: false,
      };
    }
    entrydays.push(target)
  }
  var combinedEntryDays = row.entryDays.concat(entrydays);
  row.entryDays = combinedEntryDays;

  return row;
}

//figure out which timecodes are already used to stop users from adding duplicates
export const disableExistingTimecodes = (availableData, existingData, currentWeekStart) => {
  existingData.forEach(client => {
    const clientIndex = availableData.findIndex(q => q.clientId === client.clientId);
    if (clientIndex >= 0) {
      client.projects.forEach(project => {
        const projectIndex = availableData.findIndex(q => q.projectId === project.projectId);
        if (projectIndex >= 0) {
          project.budgets.forEach(budget => {
            const budgetIndex = availableData.findIndex(q => q.budgetId === budget.budgetId);
            if (budgetIndex >= 0) {
              budget.timecodes.forEach(timecode => {
                const timecodeIndex = availableData.findIndex(q => q.taskId === timecode.taskId);
                if (timecodeIndex >= 0) {
                  // Check if this timecode has an entry for the current week
                  const hasEntryForCurrentWeek = timecode.entryDays.some(entry => entry.date.toString() === currentWeekStart.toString());
                  // Disable the timecode if it has an entry for the current week
                  availableData[timecodeIndex].isDisabled = hasEntryForCurrentWeek;
                }
              });
            }
          });
        }
      });
    }
  });

  return availableData;
};

export const UpdateTimesheetLocalState =(existing, data, day)=>{
  
  var found= false;
  for(var clientIndex=0; clientIndex< existing.length;clientIndex++){
    if(existing[clientIndex].clientId===data.clientId){
      for(var projectIndex=0; projectIndex< existing[clientIndex].projects.length;projectIndex++){      
        if(existing[clientIndex].projects[projectIndex].projectId===data.projectId){
          for(var budgetIndex=0; budgetIndex< existing[clientIndex].projects[projectIndex].budgets.length;budgetIndex++){
            if(existing[clientIndex].projects[projectIndex].budgets[budgetIndex].budgetId===data.budgetId){
              for(var timecodeIndex=0; timecodeIndex< existing[clientIndex].projects[projectIndex].budgets[budgetIndex].timecodes.length;timecodeIndex++){
                if(existing[clientIndex].projects[projectIndex].budgets[budgetIndex].timecodes[timecodeIndex].taskId===data.taskId){
                  for(var dayIndex=0; dayIndex< existing[clientIndex].projects[projectIndex].budgets[budgetIndex].timecodes[timecodeIndex].entryDays.length; dayIndex++){
                    //update te view to avoid a re-render. By this stage the entry has been successfully saved
                    if(existing[clientIndex].projects[projectIndex].budgets[budgetIndex].timecodes[timecodeIndex].entryDays[dayIndex].date===day.date){
                      day.status="open";
                      day.totalMinutes =0;
                      
                      day.entries.forEach((item)=> {
                        day.totalMinutes += item.totalMinutes;
                      });
                      
                      if (day.totalMinutes === 0) day.status = "empty";

                      existing[clientIndex].projects[projectIndex].budgets[budgetIndex].timecodes[timecodeIndex].entryDays[dayIndex]= {...day};
                      found=true;
                      break;
                    }                    
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  
  if(!found){
    throw Error("Unable to find target timecode row");
  }

  return [...existing];
}

export const setTimesheetEntryStatus = (data, status) => {
        data.forEach(client => {
            client.projects.forEach(project => {
                project.budgets.forEach(budget => {
                    budget.timecodes.forEach(timecode => {
                        timecode.entryDays.forEach(day => {
                            if (day.isReviewed)
                                day.status = "approved";
                            else if (day.totalMinutes === 0) {
                              if (status === "rejected")
                                day.status = "empty";
                              else
                                day.status = "closed";
                            }
                                
                            else
                                day.status = status;
                        });
                    });
                });
            });
        });
    }